import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { InquiryResponse } from '@models/inquiry';
import dayjs from 'dayjs';

interface Props {
    inquiry: InquiryResponse;
}

function InquiryContent({ inquiry }:Props) {
    const { content, createdAt, fileUrls } = inquiry;
    return (
        <Container>
            <Content color={colors.gray7} >{content}</Content>
            {(fileUrls && fileUrls.length !== 0) && (
                <Images>
                    {fileUrls?.map((fileUrl) => (
                        <Image src={fileUrl}
                            key={fileUrl} />
                    ))}
                </Images>
            )}
            <CreatedAtRow fullWidth justify='flex-end' >
                <Text color={colors.gray6}>
                    {dayjs(createdAt).format('YYYY.MM.DD HH:mm')}
                </Text>
            </CreatedAtRow>
        </Container>
    );
}

const Container = styled.section`
    padding: 16px 20px 14px;
    width: 100%;
`;

const Content = styled(Text)`
    white-space: pre-wrap;
`;

const CreatedAtRow = styled(Row)`
    margin-top: 16px;
`;

const Images = styled.div`
    margin-top: 12px;
    img {
        max-width: 100%;
    }
`;

export default InquiryContent;
